export default {
  namespaced: true,
  video_wall: {
    assign_a_video_wall:"Assign a video wall",
    video_wall_users: "Video wall users",
    no_view_assigned: "no view assigned",
  },
};
